import { httpRequest } from "../../../../utils/HttpRequest";
import { IPage } from "../../../../types/FmsEnums";
import { IEntitySearch, IEntityDetail } from "./entityType"
import { getVrmBaseRequestUrl } from "@src/utils/constants";

export interface paramsDisable {
    id: string,
    enable: number
}

class BeService {
    async page(searchVo: IEntitySearch) {
        const apiUrl = "/base/be/page";
        return await httpRequest.post<IPage<IEntityDetail>>(apiUrl, searchVo, { baseURL: getVrmBaseRequestUrl() });
    }
    async one(id: string) {
        const apiUrl = `/base/be/findById/${id}`;
        return await httpRequest.get<IEntityDetail>(apiUrl);
    }
    async insert(insertVo: any) {
        const apiUrl = "/base/be/insertLocal";
        return await httpRequest.post<boolean>(apiUrl, insertVo, { baseURL: getVrmBaseRequestUrl() });
    }
    async update(updateVo: any) {
        const apiUrl = "/base/be/updateLocal";
        return await httpRequest.post<boolean>(apiUrl, updateVo, { baseURL: getVrmBaseRequestUrl() });
    }
    //启用禁用
    async disable(parsms: paramsDisable) {
        const apiUrl = `/base/be/change`;
        return await httpRequest.post<boolean>(apiUrl, parsms);
    }

}
export const beService = new BeService();